export default function firstCharsToUpperCase(string, numOfChars) {
	let i = 1;
	if (typeof numOfChars !== 'undefined') {
		i = numOfChars;
	}
	return string.slice(0, i).toUpperCase() + string.slice(i);
};
